import { CitiesInterface } from '../../../interfaces/dto/cities/cities-interface';

export class CitiesModel implements CitiesInterface {
  districtId: number = -1;
  id: number = -1;
  cityId: number = -1;
  cityName: string = '';
  name: string = '';

  constructor(init?: Partial<CitiesModel>) {
    Object.assign(this, init);
  }
}
